import cx from 'classnames';

import {Icon} from '../Icon';

import {LoadingSpinnerProps} from './LoadingSpinner.types';

import * as css from './LoadingSpinner.css';

export const LoadingSpinner = ({
  className,
  size = 'normal',
  color,
  ...otherProps
}: LoadingSpinnerProps) => {
  return (
    <Icon
      name="Spinner"
      size={size}
      className={cx(className, css.root)}
      {...otherProps}
      color={color || 'currentColor'}
    />
  );
};
